<template>
  <div class="media-element element-events">
    <figure v-if="result.thumbnailImage.length">
      <a
        @click.prevent="showDetails(result)"
        :href="result.url"
      ><span class="is-sr-only">{{ result.title }}</span>
        <img
          v-for="thumbnail in result.thumbnailImage"
          :src="thumbnail.url"
          aria-hidden="true"
          v-bind:key="thumbnail.id"
        />
      </a>
    </figure>
    <figure v-else>
      <a
        @click.prevent="showDetails(result)"
        :href="result.url"
      >
        <img aria-hidden="true" :src="placeholderImage" />
      </a>
    </figure>
    <div class="element-content">
      <span
        v-if="calendarType(result)"
        class="heading-4 overline"
      >{{calendarType(result)}}</span>
      <h3 class="is-smaller heading-3">
        <a
          @click.prevent="showDetails(result)"
          :href="result.url"
        >{{ result.title }}</a>
      </h3>
      <span class="event-date is-smaller">
        <span>{{eventDates(result.startDate,result.endDate)}}</span>
        <span v-if="eventTimes(result.startDate,result.endDate)">{{eventTimes(result.startDate,result.endDate)}}</span>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { formatEventDates, formatEventTimes } from '../utils/calendars.js'
import { placeholderImage } from '../utils/assetUrl'
import { Modal } from 'buefy'
import EventDetail from '../components/eventDetail.vue'

Vue.use(Modal)

export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  data () {
    return { placeholderImage }
  },
  methods: {
    showDetails (result) {
      this.$buefy.modal.open({
        props: result,
        parent: this,
        component: EventDetail,
        customClass: ''
      })
    },
    calendarType (result) {
      if (
        typeof result.schoolCalendar !== 'undefined' &&
        result.schoolCalendar.length !== 0
      ) {
        return result.schoolCalendar[0].title
      }
      if (
        typeof result.athleticCalendar !== 'undefined' &&
        result.athleticCalendar.length === 3
      ) {
        return (
          result.athleticCalendar[1].title +
          ' - ' +
          result.athleticCalendar[2].title
        )
      }
    },
    eventDates (startDate, endDate) {
      return formatEventDates(startDate, endDate)
    },
    eventTimes (startDate, endDate) {
      return formatEventTimes(startDate, endDate)
    }
  }
}
</script>
